document.addEventListener('alpine:init', () => {
  Alpine.store('wistiaPopup', {
    video: null,
    container: null,
    content: null,

    init() {
      if (!document.getElementById('wistia')) {
        const script = document.createElement('script');
        script.src = 'https://fast.wistia.com/player.js';
        script.id = 'wistia';
        script.async = true;
        document.head.append(script);
      }

      this.container = document.getElementById('wistia-popup-container');
      this.content = document.getElementById('wistia-popup-content');
    },

    open(id, width, height) {
      this.video = { id, width, height };
      this.container.style.aspectRatio = `${width} / ${height}`;
      this.content.innerHTML = `<script src="https://fast.wistia.com/embed/${id}.js" async type="module"></script>
      <style>wistia-player[media-id='${id}']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/${id}/swatch'); display: block; filter: blur(5px); padding-top: ${
        (height / width) * 100
      }%; }</style>
      <wistia-player media-id="${id}" aspect="${width / height}" autoplay="true"></wistia-player>`;
    },

    close() {
      if (this.video) {
        this.video = null;
        setTimeout(() => {
          this.content.innerHTML = '';
        }, 500);
      }
    },
  });
});